import axios from "axios";
import * as config from "../../../app.config";
import { setHeaders } from "../../../utils/basic";
import { useQuery } from "react-query";

const fetchRunInfo = async (plateId) => {
    const headerConfig = setHeaders();
    const { data } = await axios.get(
        `${config.ENDPOINTS["datalake"]}/ddpcr/run_info/${plateId}`,
        { headers: headerConfig }
    );
    return data;
};

export default function useFetchDdpcrRunInfo(plateId) {
    return useQuery(["ddpcrRunInfo", plateId], () => fetchRunInfo(plateId), {
        enabled: !!plateId,
        onError: (error) => console.log({ error }),
    });
}
